var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid broadcast-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"}),_c('div',{staticClass:"col-12 col-md-9"},[_c('Video',{attrs:{"email":_vm.email,"educatorId":_vm.educatorId}})],1),_c('div',{staticClass:"col"})]),_c('v-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }